<template>
  <div class="table-header-item">
    {{ title }}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.table-header-item {
  font-size: $mediumTextSize;
  font-weight: 500;
  flex: 1;
  &:last-child{
    flex: 2;
  }
}
</style>
